import React, { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

//import scss
import "./tournament-settings-donation-watch-email-delete.scss";
import { useMatch, useNavigate } from "react-router-dom";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { getRemoveTitle, removeItemForm } from "../../../forms/DeleteForm";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDonationWatchItem,
  getTournamentDonationWatchItem,
  selectCurrentDonationWatchItem,
  selectTournamentNotifications,
} from "../../../reducers/tournamentSlice";
import { useNotificationNavigation } from "../../../hooks/notificationHooks";
import TournamentPackageWatchItem from "../tournament-promotion/tournament-packages/tournament-package-watch-item";
//Name the component
const TournamentSettingsDonationWatchItemEmailDelete = (props) => {
  const notifications = useSelector(selectTournamentNotifications);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentWatchItem = useSelector(selectCurrentDonationWatchItem);

  const match = useMatch(
    "/:tournamentID/settings/payments/watch/:watchID/delete"
  );

  useEffect(() => {
    if (match?.params?.watchID) {
      dispatch(getTournamentDonationWatchItem(match.params.watchID));
    }
  }, [match?.params?.watchID, dispatch]);

  useNotificationNavigation(
    "removed",
    notifications,
    -2,
    "Donation Watch Item"
  );

  const save = () => {
    dispatch(deleteDonationWatchItem(match.params.watchID));
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "delete",
        action: save,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Delete Email`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete Email")}
        formSections={removeItemForm(
          "Donation Watch Email",
          <TournamentPackageWatchItem {...currentWatchItem}/>, "delete", `Are you sure you want to delete ${currentWatchItem.email}? They will no longer receive watch emails for donations.`
        )}
      ></GSForm>
    );
  };

  const timeoutAction = () => {};

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-settings-donation-watch-email-delete>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-settings-donation-watch-email-delete>
  );
};

//export the new namet
export default TournamentSettingsDonationWatchItemEmailDelete;
